import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import BrandLogo from './BrandLogo';

function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="ft-row">
        <div className="ft-brand">
          <span className="brand-mark">
            <BrandLogo />
          </span>
          <span className="brand-name">network</span>
        </div>
        <div className="ft-links">
          <a href="https://app.0v.network" target="_blank" rel="noreferrer">{t('footer.console')}</a>
          <a href="#models">{t('footer.models')}</a>
          <a href="/about.html">{t('footer.about')}</a>
          <a href="/privacy.html">{t('footer.privacy')}</a>
          <a href="/terms.html">{t('footer.terms')}</a>
        </div>
        <div className="ft-meta">
          <span>© 2026 0v.network</span>
          <span>·</span>
          <a href="mailto:support@0v.network">support@0v.network</a>
          <span>·</span>
          <span>{t('footer.built')}</span>
        </div>
      </div>
      <div className="ft-ascii" aria-hidden="true">
        <pre>{`> end of transmission ────────────────────────────────────────  EOF`}</pre>
      </div>
    </footer>
  );
}

export default Footer;
